import { type ToastContentProps } from "react-toastify";
import Spacing from "../Spacing";
import { Icon } from "../Icon";
import Text from "../Text";
import styles from "./Toasts.module.scss";
import { type ToastData, type ToastVariant, TOAST_CONFIG } from "./toast.types";

interface BaseToastData extends ToastData {
  variant: ToastVariant;
}

// Don't use FC - define the function directly with explicit return type
function BaseToast({
  data,
}: ToastContentProps<BaseToastData>): React.ReactElement | null {
  if (!data) return null;

  const { title, content, iconName, variant } = data;
  const config = TOAST_CONFIG[variant];

  return (
    <Spacing display="flex" gap={2} className={styles.toastWrapper}>
      <Spacing>
        <Spacing className={styles.iconWrapper}>
          <Icon
            name={iconName ?? config.iconName}
            size={20}
            className={styles[config.iconClassName]}
          />
        </Spacing>
      </Spacing>
      <Spacing display="flex" direction="column" gap={1}>
        <Text fontSize={16} fontWeight={600}>
          {title}
        </Text>
        <Text fontSize={16} fontWeight={600} opacity={50}>
          {content}
        </Text>
      </Spacing>
    </Spacing>
  );
}

export default BaseToast;
